import {
  Component,
  forwardRef,
  OnInit,
  Injector,
  AfterContentInit,
  Input,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';

import { FormCommonFunctions2 } from '../form-common-functions';
import { GlobalService } from '../../../global/index';

@Component({
  selector: 'appForm2-list-calendar',
  styleUrls: ['../form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ListFormCalendar2Component),
      multi: true,
    },
  ],
  template: `
    <div class="p-col-12 p-g-nopad">
      <p-calendar
        hourFormat="24"
        class="calendar"
        [locale]="locale"
        dataType="string"
        [(ngModel)]="value"
        dateFormat="yy-mm-dd"
        [showTime]="showTime"
        [style]="{ width: '100%' }"
        inputStyleClass="form-control"
        (onInput)="pushChanges(value)"
        (onSelect)="pushChanges(value)"
        (ngModelChange)="pushChanges($event)"
        (onBlur)="blurEvent()"
        [showIcon]="true"
        [selectionMode]="selectionMode"
        [monthNavigator]="true"
        [yearNavigator]="yearNavigator"
        [yearRange]="yearRange"
        [inline]="inline"
        [placeholder]="htmlAttributes['label']['value'] || control['label']"
        [attr.id]="htmlAttributes['input']['id']"
        [attr.form-control-name]="control['name']"
        [showWeek]="true"
        [inputStyle]="
          control.showErrors
            ? { border: 'solid 1px #f25858', width: 'calc(100% - 2.143em)' }
            : { width: 'calc(100% - 2.143em)' }
        "
      >
        <ng-template pTemplate="date" let-date>
          <span [class.is-red-day]="isRedDay(date)">{{ date.day }}</span>
        </ng-template>
      </p-calendar>
      <div *ngIf="control.showErrors" class="vendium-tool-tip">
        <p
          *ngFor="let error of control.mergedErrors"
          class="form-control-feedback"
        >
          <span><i class="fa fa-times"></i> </span
          ><span [innerHTML]="error"></span>
        </p>
      </div>
    </div>
  `,
})
export class ListFormCalendar2Component
  extends FormCommonFunctions2
  implements ControlValueAccessor, OnInit, AfterContentInit
{
  @Input() public highlightRedDays = false;
  locale;
  value: any;
  disabled: boolean;
  ngControl: NgControl;
  onTouched: () => void;
  onChange: (_: any) => void;

  constructor(private inj: Injector, private globalService: GlobalService) {
    super();
    this.locale = this.globalService.getLocale('sv');
  }

  public isRedDay(date: any): boolean {
    const day = new Date(date.year, date.month, date.day);
    return this.highlightRedDays && day.getDay() === 0;
  }

  ngOnInit() {
    super.ngOnInit();
    this.ngControl = this.inj.get(NgControl);
    this.control = this.ngControl;
  }

  ngAfterContentInit() {
    this.control = this.ngControl.control;
  }

  writeValue(value: any): void {
    this.value = value;
  }
  pushChanges(value: any): void {
    this.onChange(value);
  }

  blurEvent(): void {
    this.onBlur.emit(true);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
